import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Header from './components/Layout/Header';
import HomePage from './pages/HomePage';
import AssessmentPage from './pages/AssessmentPage';
import ResultsPage from './pages/ResultsPage';
import SignUpPage from './pages/SignUpPage';
import VerificationPage from './pages/VerificationPage';
import DevView from './pages/DevView';
import ErrorBoundary from './components/ErrorBoundary';
import { ScoreProvider } from './context/ScoreContext';
import { UserProvider } from './context/UserContext';

function App() {
  return (
    <ErrorBoundary>
      <UserProvider>
        <ScoreProvider>
          <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
            <Header />
            <Container maxWidth="lg" sx={{ py: 4 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/assessment" element={<AssessmentPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/verification" element={<VerificationPage />} />
              <Route path="/dev" element={<DevView />} />
            </Routes>
            </Container>
          </Box>
        </ScoreProvider>
      </UserProvider>
    </ErrorBoundary>
  );
}

export default App;